import React, { useContext, useEffect } from "react";
import { AppContext } from "../App";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const dict = {
  el: {
    title: "Όροι Χρήσης & Πολιτική Απορρήτου | VrestoEdo.gr",
    h1: "Όροι Χρήσης & Πολιτική Απορρήτου",
    last_updated: "Τελευταία ενημέρωση: Νοέμβριος 2025",
    https_badge: "✔ Ασφαλής σύνδεση (HTTPS)",
    back_home: "Πίσω στην Αρχική",
    sec1_title: "1. Σκοπός του ιστότοπου",
    sec1_p1:
      "Το VrestoEdo.gr παρέχει συνδέσμους και πληροφορίες για τον εντοπισμό ηλεκτρονικών υπηρεσιών, εντύπων και ιστοσελίδων του Δημοσίου ή άλλων φορέων. Δεν αποτελεί επίσημη κρατική πλατφόρμα και δεν φέρει ευθύνη για την ακρίβεια ή τη διαθεσιμότητα των εξωτερικών συνδέσμων.",
    sec2_title: "2. Πνευματικά δικαιώματα",
    sec2_p1:
      "Όλο το περιεχόμενο του ιστότοπου (κείμενα, σχεδίαση, λογότυπα κ.λπ.) προστατεύεται από τη νομοθεσία περί πνευματικής ιδιοκτησίας. Επιτρέπεται η αναπαραγωγή με αναφορά στην πηγή και σύνδεσμο προς το VrestoEdo.gr.",
    sec3_title: "3. Εξωτερικοί σύνδεσμοι",
    sec3_p1:
      "Ο ιστότοπος περιλαμβάνει συνδέσμους προς τρίτες ιστοσελίδες (π.χ. gov.gr, ΑΑΔΕ, e-ΕΦΚΑ). Το VrestoEdo.gr δεν ευθύνεται για το περιεχόμενο, την πολιτική απορρήτου ή την ορθότητα των πληροφοριών αυτών των ιστοσελίδων.",
    sec4_title: "4. Συλλογή και χρήση δεδομένων",
    sec4_p1:
      "Ο ιστότοπος δεν συλλέγει προσωπικά δεδομένα χρηστών (όπως ονόματα, emails ή τηλέφωνα), εκτός αν ο χρήστης επικοινωνήσει οικειοθελώς μέσω φόρμας ή email. Τα δεδομένα αυτά χρησιμοποιούνται αποκλειστικά για απάντηση στο αίτημα επικοινωνίας και δεν κοινοποιούνται σε τρίτους.",
    sec5_title: "5. Cookies, Google Analytics & Google AdSense",
    sec5_p1:
      "Μπορεί να χρησιμοποιούμε cookies για βελτίωση εμπειρίας και για ανώνυμα στατιστικά χρήσης μέσω Google Analytics. Μέσω Google AdSense ενδέχεται να προβάλλονται προσωποποιημένες διαφημίσεις. Η Google μπορεί να χρησιμοποιεί cookies (π.χ. DoubleClick) για να εμφανίζει διαφημίσεις βάσει προηγούμενων επισκέψεων. Μπορείτε να απενεργοποιήσετε την προσωποποίηση από τη σελίδα Ρυθμίσεις Διαφημίσεων.",
    ads_settings: "Ρυθμίσεις Διαφημίσεων",
    sec6_title: "6. Ασφάλεια",
    sec6_p1:
      "Το VrestoEdo.gr χρησιμοποιεί ασφαλή σύνδεση (https://) για την προστασία των δεδομένων κατά την περιήγηση. Παρά τα μέτρα ασφαλείας, δεν είναι δυνατή η πλήρης εγγύηση για τη μετάδοση πληροφοριών μέσω διαδικτύου.",
    sec7_title: "7. Τροποποιήσεις",
    sec7_p1:
      "Οι όροι χρήσης και η πολιτική απορρήτου ενδέχεται να ενημερώνονται περιοδικά χωρίς προειδοποίηση. Η συνεχής χρήση του ιστότοπου σημαίνει αποδοχή των ενημερωμένων όρων.",
    sec8_title: "8. Επικοινωνία",
    sec8_p1:
      "Για απορίες σχετικά με τους όρους χρήσης ή την πολιτική απορρήτου, επικοινωνήστε στο: ",
    email: "info@vrestoedo.gr",
    footer: "© {year} VrestoEdo.gr  -  Όλα τα δικαιώματα διατηρούνται.",
  },
  en: {
    title: "Terms of Use & Privacy Policy | VrestoEdo.gr",
    h1: "Terms of Use & Privacy Policy",
    last_updated: "Last updated: November 2025",
    https_badge: "✔ Secure connection (HTTPS)",
    back_home: "Back to Home",
    sec1_title: "1. Purpose of the Website",
    sec1_p1:
      "VrestoEdo.gr provides links and information to help users find e-services, forms and websites of public bodies or other organizations. It is not an official government platform and is not responsible for the accuracy or availability of external links.",
    sec2_title: "2. Intellectual Property",
    sec2_p1:
      "All content on this website (texts, design, logos, etc.) is protected by intellectual property laws. Reproduction is permitted with attribution and a link to VrestoEdo.gr.",
    sec3_title: "3. External Links",
    sec3_p1:
      "The website includes links to third-party sites (e.g., gov.gr, AADE, e-EFKA). VrestoEdo.gr is not responsible for the content, privacy policies, or accuracy of information on those sites.",
    sec4_title: "4. Data Collection and Use",
    sec4_p1:
      "We do not collect personal data (such as names, emails or phone numbers) unless the user voluntarily contacts us via form or email. Such data is used solely to respond to the inquiry and is not shared with third parties.",
    sec5_title: "5. Cookies, Google Analytics & Google AdSense",
    sec5_p1:
      "We may use cookies to improve browsing experience and for anonymous usage statistics via Google Analytics. Through Google AdSense, personalized ads may be displayed. Google may use cookies (e.g., DoubleClick) to show ads based on prior visits. You can disable ad personalization on the Ads Settings page.",
    ads_settings: "Ads Settings",
    sec6_title: "6. Security",
    sec6_p1:
      "VrestoEdo.gr uses a secure connection (https://) to protect data during browsing. Despite security measures, full guarantee of information transmission over the Internet is not possible.",
    sec7_title: "7. Changes",
    sec7_p1:
      "These Terms and this Privacy Policy may be updated periodically without notice. Continued use of the site constitutes acceptance of the updated terms.",
    sec8_title: "8. Contact",
    sec8_p1:
      "For questions about these Terms or this Privacy Policy, contact: ",
    email: "info@vrestoedo.gr",
    footer: "© {year} VrestoEdo.gr  -  All rights reserved.",
  },
};

export default function TermsPrivacy() {
  const { language } = useContext(AppContext);
  const navigate = useNavigate();
  const t = dict[language] || dict.el;

  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }, []);

  useEffect(() => {
    document.title = t.title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        language === "el"
          ? "Όροι Χρήσης και Πολιτική Απορρήτου του VrestoEdo.gr"
          : "Terms of Use and Privacy Policy of VrestoEdo.gr"
      );
    }
  }, [language, t]);

  const year = new Date().getFullYear();

  return (
    <main className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-10">
      <article className="rounded-2xl border border-white/10 bg-white/5 shadow-xl overflow-hidden">
        <div className="p-6 md:p-8 border-b border-white/10 bg-white/5">
          <div className="flex items-center justify-between gap-4">
            <h1 className="text-xl md:text-3xl font-extrabold">{t.h1}</h1>
            <button
			  onClick={() => {
				navigate("/");
				setTimeout(() => {
				  window.scrollTo({ top: 0, behavior: "smooth" });
				}, 300); // μικρή καθυστέρηση για να προλάβει το navigation
			  }}
			  className="
				flex items-center gap-1 text-sm text-blue-100 
				px-2 py-1 rounded-lg border border-white/20 
				bg-white/10 backdrop-blur-md 
				hover:bg-white/20 transition-all duration-500 ease-in-out
			  "
			>
			  <ArrowLeft size={14} />
			  {t.back_home}
			</button>

          </div>
          <p className="mt-2 text-sm text-white/70">{t.last_updated}</p>
          <span className="mt-3 inline-flex text-green-400 text-sm font-bold bg-green-400/10 px-3 py-1 rounded-lg">
            {t.https_badge}
          </span>
        </div>

        <section className="p-6 md:p-8">
          <h2 className="text-lg md:text-xl font-bold mb-1">{t.sec1_title}</h2>
          <p className="text-white/80">{t.sec1_p1}</p>
        </section>

        <section className="p-6 md:p-8 border-t border-white/10">
          <h2 className="text-lg md:text-xl font-bold mb-1">{t.sec2_title}</h2>
          <p className="text-white/80">{t.sec2_p1}</p>
        </section>

        <section className="p-6 md:p-8 border-t border-white/10">
          <h2 className="text-lg md:text-xl font-bold mb-1">{t.sec3_title}</h2>
          <p className="text-white/80">{t.sec3_p1}</p>
        </section>

        <section className="p-6 md:p-8 border-t border-white/10">
          <h2 className="text-lg md:text-xl font-bold mb-1">{t.sec4_title}</h2>
          <p className="text-white/80">{t.sec4_p1}</p>
        </section>

        <section className="p-6 md:p-8 border-t border-white/10">
          <h2 className="text-lg md:text-xl font-bold mb-1">{t.sec5_title}</h2>
          <p className="text-white/80">
            {t.sec5_p1}{" "}
            <a
              href="https://adssettings.google.com/"
              className="underline hover:text-blue-300"
              target="_blank"
              rel="noreferrer"
            >
              {t.ads_settings}
            </a>
            .
          </p>
        </section>

        <section className="p-6 md:p-8 border-t border-white/10">
          <h2 className="text-lg md:text-xl font-bold mb-1">{t.sec6_title}</h2>
          <p className="text-white/80">{t.sec6_p1}</p>
        </section>

        <section className="p-6 md:p-8 border-t border-white/10">
          <h2 className="text-lg md:text-xl font-bold mb-1">{t.sec7_title}</h2>
          <p className="text-white/80">{t.sec7_p1}</p>
        </section>

        <section className="p-6 md:p-8 border-t border-white/10">
          <h2 className="text-lg md:text-xl font-bold mb-1">{t.sec8_title}</h2>
          <p className="text-white/80">
            {t.sec8_p1}
            <strong>
              <a className="underline hover:text-blue-300" href="mailto:info@vrestoedo.gr">
                {t.email}
              </a>
            </strong>
          </p>
        </section>
      </article>

      <footer className="mt-6 text-sm text-white/60">
        {t.footer.replace("{year}", String(year))}
      </footer>
    </main>
  );
}
